import React from 'react';
import { Helmet } from 'react-helmet';

import { 
  Navbar, 
  Landing, 
  About, 
  Experience,
  Skills, 
  Projects, 
  Education,
  Achievement, 
  Contacts,
  Footer
} from '../../components';
import { headerData } from '../../data/headerData';

function Main() {
    return (
        <div className="main">
            <Helmet>
                <title>{headerData.name} — Full Stack Web Developer</title>
            </Helmet>
            <Navbar />        
            <Landing />
            <About />
            <Experience />
            <Skills />
            <Projects />
            <Education />
            <Achievement />
            <Contacts />
            <Footer />
        </div>
    );
}

export default Main;
